import React from 'react';
import { format } from 'react-string-format';
import Pusher from 'pusher-js';
import * as ReactDOM from "react-dom";
import Game from "../Game";
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import {Col, Container, ListGroup, Row} from "react-bootstrap";

var fileDownload = require('js-file-download');

class ModeratorGameReview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            item: {},
            actions: [],
            actionsIsLoaded: false,
        };
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + "/customer/game/"+this.props.gameId+"/stats", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        item: result
                    });
                },

                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )

        fetch(process.env.REACT_APP_API_URL + "/moderator/games/"+this.props.gameId.toString()+"/actions/"+this.props.moderatorId, {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        actionsIsLoaded: true,
                        actions: result
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        actionsIsLoaded: true,
                        error
                    });
                }
            )
    }

    approve(e) {
        e.preventDefault();

        const { navigate } = this.props;

        let status = 'active';

        const body = {'approve': true, 'status': status, 'user_id': this.props.moderatorId};
        console.log(body);

        fetch(format(process.env.REACT_APP_API_URL + '/moderator/games/{0}', e.target.game_id.value), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                navigate('/moderator')
            );
    }

    updateRequired(e) {
        e.preventDefault();

        const { navigate } = this.props;

        const body = {'approve': false, 'status': 'update_required', 'user_id': this.props.moderatorId, 'attached_message': e.target.message.value};

        fetch(format(process.env.REACT_APP_API_URL + '/moderator/games/{0}', e.target.game_id.value), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                navigate('/moderator')
            );
    }

    cancelGame(e) {
        e.preventDefault();

        const { navigate } = this.props;

        const body = {'approve': false, 'status': 'cancelled', 'user_id': this.props.moderatorId, 'attached_message': e.target.message.value};

        fetch(format(process.env.REACT_APP_API_URL + '/moderator/games/{0}', e.target.game_id.value), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                navigate('/moderator')
            );
    }


    invokeGameRemove(e) {
        e.preventDefault();

        const { navigate } = this.props;

        const body = {'approve': false, 'status': 'will-be-removed', 'user_id': this.props.moderatorId, 'attached_message': e.target.message.value};

        fetch(format(process.env.REACT_APP_API_URL + '/moderator/games/{0}', e.target.game_id.value), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                navigate('/moderator')
            );
    }

    changeESIndex(e) {
        e.preventDefault();

        const { navigate } = this.props;

        const body = {'es_index': e.target.es_index.value, 'user_id': this.props.moderatorId};

        fetch(format(process.env.REACT_APP_API_URL + '/moderator/games/{0}/es-index', e.target.game_id.value), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                navigate('/moderator')
            );
    }

    takeForReview(e) {
        e.preventDefault();

        const { navigate } = this.props;

        let status = 'in_review';

        if (this.state.item.game.active === true){
            status = 'update_in_review';
        }

        const body = {'approve': false, 'status': status, 'user_id': this.props.moderatorId};

        fetch(format(process.env.REACT_APP_API_URL + '/moderator/games/{0}', e.target.game_id.value), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                navigate('/moderator')
            );
    }

    render() {
        const { error, isLoaded, item, actions, actionsIsLoaded } = this.state;

        let descriptionImages = null;
        if (isLoaded && item.game.game_page.description_images) {
            descriptionImages = <div class="alert alert-success" style={{
                width: "100%",
                overflowX: "auto",
                whiteSpace: "nowrap",
            }}>
                {item.game.game_page.description_images.map(img => (
                    <img style={{borderRadius: 5, marginRight: 5}} width="450" src={img}></img>
                ))}
            </div>;
        }

        let content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (!isLoaded || !actionsIsLoaded) {
            content = <div>Loading...</div>;
        } else {
            content = (
                <div>
                    <center>
                        <h1>{item.game.name}</h1>

                        <div className="alert alert-danger">
                            <center>
                                <form onSubmit={this.approve.bind(this)}>
                                    <input hidden type="number" name="game_id" value={item.game.id}/>
                                    <input className="btn btn-outline-danger" type="submit" value="Approve"/>
                                </form>
                            </center>
                            <h3>Change game status</h3>
                            <div className="row">
                                <form className="col-sm" onSubmit={this.updateRequired.bind(this)}>
                                    <input hidden type="number" name="game_id" value={item.game.id}/>
                                    <textarea className="form-control" name="message" required placeholder="Message:"/>
                                    <input className="btn btn-danger" type="submit" value="Request changes"/>
                                </form>
                                <form className="col-sm" onSubmit={this.cancelGame.bind(this)}>
                                    <input hidden type="number" name="game_id" value={item.game.id}/>
                                    <textarea className="form-control" name="message" required placeholder="Message:"/>
                                    <input className="btn btn-danger" type="submit" value="Cancel"/>
                                </form>
                                <form className="col-sm" onSubmit={this.invokeGameRemove.bind(this)}>
                                    <input hidden type="number" name="game_id" value={item.game.id}/>
                                    <textarea className="form-control" name="message" required placeholder="Message:"/>
                                    <input className="btn btn-danger" type="submit" value="Invoke remove"/>
                                </form>
                            </div>
                        </div>
                    </center>


                    <div  class="alert alert-warning">
                        <h4><a href={"/publishers/" + item.publisher_id} class="btn btn-outline-primary">Publisher</a></h4>
                        <h4>Status: {item.game.status}</h4>
                        <h4>{item.game.approved ? 'Approved' : 'Not approved yet'}</h4>
                        <form onSubmit={this.takeForReview.bind(this)}>
                            <input hidden type="number" name="game_id" value={item.game.id}/>
                            <input class="btn btn-primary" type="submit" value="Take for review"/>
                        </form>
                    </div>

                    <div class="alert alert-success">
                        <div class="row">
                            <img style={{
                                width: "50%",
                                maxWidth: "50%",
                                height: "50%",
                                maxHeight: "50%",
                                minHeight: "50%",
                                borderRadius: 9,
                                borderColor: "darkgray",
                            }} src={item.game.game_page.background_image_url} class="col-sm-9" ></img>

                            <img style={{
                                width: "20%",
                                maxWidth: "20%",
                                height: "20%",
                                maxHeight: "20%",
                                minHeight: "20%",
                                borderRadius: 9,
                                borderColor: "darkgray",
                            }} src={item.game.game_page.icon_url} width="150" class="col-sm"></img>
                        </div>
                        <br/>
                        {descriptionImages}
                        <NavLink className="btn btn-primary" to={"/games/"+item.game.id.toString()}>
                            More
                        </NavLink>
                        <br/>
                        <br/>
                        <ListGroup className="list-group-flush">
                            <ListGroup.Item>{item.game.genre.charAt(0).toUpperCase() + item.game.genre.slice(1)}</ListGroup.Item>
                            <ListGroup.Item>{item.game.game_category ? "Category: " + item.game.game_category.name : ""}</ListGroup.Item>

                            <ListGroup.Item>
                                <img width="35" src="https://www.freeiconspng.com/uploads/downloads-icon-15.png"/>
                                <span style={{fontSize: 20}}>{item.downloads}</span>

                                <img style={{
                                    marginLeft: 20
                                }} width="35" src="https://www.pngall.com/wp-content/uploads/3/Heart-PNG-Photo-Image.png"/>
                                {
                                    item.likes_percentage > -1 ?
                                        <span style={{fontSize: 20}}>{item.likes_percentage}%</span>
                                        :<span></span>
                                }
                            </ListGroup.Item>
                        </ListGroup>
                        <br/>

                        <h3>ES Index</h3>
                            <div style={{
                                width: 300
                            }}>
                                <form className="d-flex" onSubmit={this.changeESIndex.bind(this)}>
                                    <input hidden type="number" name="game_id" value={item.game.id}/>
                                    <input className="me-2 form-control" type="number" name="es_index"
                                           defaultValue={item.game.es_index}/>
                                    <input className="btn btn-danger ms-1" type="submit" value="Change"/>
                                </form>
                            </div>
                    </div>
                    <br/>
                    <div className="alert alert-warning">
                        <p>Price: {item.game.paid_product ? (item.game.paid_product.new_price >= 0 ? (item.game.paid_product.new_price + "[new], " + item.game.paid_product.price + "[old]") : item.game.paid_product.price) + " " + item.game.paid_product.currency : 0}</p>
                        <br/>
                        <h2>Security section</h2>
                        {item.game.game_security
                            ? <div class="alert alert-dark">
                                <p>{item.game.game_security.has_ads ? "Has ads" : "No ads"}</p>
                                <p>{item.game.game_security.ads_providers.join(', ')}</p>
                                <p>{item.game.game_security.privacy_policy_url}</p>
                                <p>Minimum age: {item.game.game_security.minimum_age}</p>
                                <p>Sensitive content: {item.game.game_security.sensitive_content.toString()}</p>
                            </div>
                            : <div>No data provided</div>}
                    </div>
                    <br/>
                    <div className="alert alert-warning">
                        <NavLink
                            to={"/publishers/" + item.game.company_id.toString()}
                            className="btn btn-warning"
                        >
                            Publisher info
                        </NavLink>
                    </div>

                    <div>
                        <h2>Recent activity</h2>
                        {actions.map(item => (
                            <div class="alert alert-dark">
                                <hr/>
                                <NavLink
                                    to={"/games/" + item.game_id.toString()}
                                    className="btn btn-dark"
                                >
                                    {item.game.name} - {item.type}
                                </NavLink>
                                <br/>
                                Fields:
                                {item.fields.map(item => (<li>{item}</li>))}
                            </div>
                        ))}
                        <hr/>
                    </div>
                </div>
            );
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>
    }
}

export default withRouter(ModeratorGameReview);
